import ResourceLink from 'components/common/digitalResourcesMaps/resourceLink';
import React, { useCallback } from 'react';
import { IDResource, MapGroupProps } from 'types';
import { getPictureByUrl, onFaviconError } from 'utils/helpers/resourcesMap';

const TechnologySkillsLink: React.FC<MapGroupProps> = ({
  resources,
  onHoveredElementChanged,
  onClick,
}) => {
  const onElementHover = useCallback(
    (resource?: IDResource, target?: SVGElement) => {
      if (onHoveredElementChanged) {
        onHoveredElementChanged(resource, target);
      }
    },
    [onHoveredElementChanged]
  );

  const resource1SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <path
        fill="#FFF"
        stroke="#FFF205"
        strokeMiterlimit="10"
        strokeWidth="4"
        d="M851.2 403.1l-33.4 12.1c-6.7 2.4-14.1-1-16.5-7.7l-12-33.1c-2.4-6.7 1-14.1 7.7-16.5l33.4-12.1c6.7-2.4 14.1 1 16.5 7.7l12 33.1c2.4 6.7-1.1 14.1-7.7 16.5z"
      />
      <image
        width="48"
        height="48"
        x="800"
        y="356.5"
        transform="rotate(-19.93 824 380.5)"
        href={getPictureByUrl(resources[0]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource2SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <path
        fill="#FFF"
        stroke="#FFF205"
        strokeMiterlimit="10"
        strokeWidth="4"
        d="M935 403.4l-34-5.1c-7.3-1.1-12.4-8-11.3-15.3l5.1-33.7c1.1-7.3 8-12.4 15.3-11.3l34 5.1c7.3 1.1 12.4 8 11.3 15.3l-5.1 33.7c-1.1 7.3-8 12.4-15.3 11.3z"
      />
      <image
        width="48"
        height="48"
        x="898.5"
        y="346.5"
        transform="rotate(8.58 922.5 370.5)"
        href={getPictureByUrl(resources[1]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource3SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <path
        fill="#FFF"
        stroke="#FFF205"
        strokeMiterlimit="10"
        strokeWidth="4"
        d="M893.4 458.2l-33.4 7.3c-7.3 1.6-14.5-3-16.1-10.3l-7.2-33.1c-1.6-7.3 3-14.5 10.3-16.1l33.4-7.3c7.3-1.6 14.5 3 16.1 10.3l7.2 33.1c1.6 7.3-3 14.5-10.3 16.1z"
      />
      <image
        width="48"
        height="48"
        x="846.5"
        y="408"
        transform="rotate(-12.3 870.5 432)"
        href={getPictureByUrl(resources[2]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource4SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <path
        fill="#FFF"
        stroke="#FFF205"
        strokeMiterlimit="10"
        strokeWidth="4"
        d="M958.1 471.8l-34.2-5.2c-7.3-1.1-12.3-7.9-11.2-15.2l5.1-33.9c1.1-7.3 7.9-12.3 15.2-11.2l34.2 5.2c7.3 1.1 12.3 7.9 11.2 15.2l-5.1 33.9c-1.1 7.3-7.9 12.3-15.2 11.2z"
      />
      <image
        width="48"
        height="48"
        x="922"
        y="415"
        transform="rotate(8.58 946 439)"
        href={getPictureByUrl(resources[3]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );
  const resource5SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <path
        fill="#FFF"
        stroke="#FFF205"
        strokeMiterlimit="10"
        strokeWidth="4"
        d="M908.5 534.7l-35.7.5c-7.1.1-12.9-5.6-13-12.6l-.5-35.4c-.1-7.1 5.6-12.9 12.6-13l35.7-.5c7.1-.1 12.9 5.6 13 12.6l.5 35.4c.1 7.1-5.6 12.9-12.6 13z"
      />
      <image
        width="48"
        height="48"
        x="866.2"
        y="480"
        transform="rotate(-0.76 890.2 504)"
        href={getPictureByUrl(resources[4]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource6SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <path
        fill="#FFF"
        stroke="#FFF205"
        strokeMiterlimit="10"
        strokeWidth="4"
        d="M978.5 539.7l-34.2-5.2c-7.3-1.1-12.3-7.9-11.2-15.2l5.1-33.9c1.1-7.3 7.9-12.3 15.2-11.2l34.2 5.2c7.3 1.1 12.3 7.9 11.2 15.2l-5.1 33.9c-1.1 7.2-7.9 12.3-15.2 11.2z"
      />
      <image
        width="48"
        height="48"
        x="942"
        y="483"
        transform="rotate(8.58 966 507)"
        href={getPictureByUrl(resources[5]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  return (
    <g id="group-2" transform="translate(0, -73)">
      <g id="element-2">
        <g id="component-item-2">
          <g id="technology_x5F_skills">
            <path
              fill="#68C902"
              d="M1087.5 763.3c-21.7-2.7-43.4-4.5-65.2-5.5-21.8-.9-43.7-1-65.5-.2-3.3-.5-6.6-1-9.9-1.6 1.6-.4 3.1-.8 4.7-1.2-.3-.5-.6-.6-.9-.3-.1-.4-.6-3.1-.5-4.9.2-1.8.4-3.1.3-3.5.3.1.7.9.7 1.8 0-1.3.2-2.4.5-3 .3-.6.6-2.1.3-3.1.4-.2 1.5 3.1 1.3 7.8.2-1 .5-1.4.7-1.5v.2c.6-2.9 1-4.9.8-5.9.7.6 1.5 2.8 1.4 4.9.3-3.1.9-5.4 1.7-6.6.8-1.3 1.9-4.5 1.2-7 .8 0 2.1 4.6 2.3 11.3.3-.4.5-.7.8-.9.6-.4 1.7-1.8 1.5-3.8.4.3.8 2.8.7 6.1.5-.8 1-1.3 1.5-2.2 1.9-3.5 1.9-4.7 2-8.3 0-.8.5-1.1.7-.5.3.8.5 1.7.7 2.7.6.3 1.3 1.9 1.3 3.6.1-2.7.6-4.8 1.2-6.1.6-1.3 1.4-4.3.8-6.3.9-.3 3 6.3 2.2 15.9.4-2.1 1.1-2.7 1.4-3.1v.4c1.3-5.9 2.4-9.9 2-12 1.5 1.3 3 5.8 2.6 10 .8-6.3 2.3-10.9 3.9-13.4 1.7-2.5 4.3-8.9 3.1-14.2 1.6 0 4.1 9.4 3.9 23.2.6-.9 1.2-1.5 1.7-1.8 1.3-.7 3.6-3.5 3.4-7.7.8.7 1.4 5.8.9 12.5 1.1-1.5 2.2-2.6 3.2-4.3 4.1-6.9 4.3-9.5 4.8-16.7.1-1.7 1.2-2.1 1.6-1 1.9 5.7 2.1 12.7.4 20.7-.8 3.8-1.7 7-2.7 9.6h1.2l.1-.1c.7-1.1 1.5-1.8 2.2-2.9 2.6-4.3 2.7-5.9 3.1-10.4.1-1.1.8-1.3 1-.6 1.1 3.6 1.2 7.9.2 13-.1.4-.2.7-.2 1.1 1.3 0 2.7 0 4.1.1 0-.3.1-.6.1-.9.4-2.4.9-4 .7-4.6.4.2.8 1.3.7 2.4.2-1.7.6-3.1 1-3.9.4-.8 1.1-2.7.7-4 .6-.2 1.7 4.2.9 10.4.3-1.3.8-1.7 1-2v.2c1-3.7 1.9-6.3 1.7-7.7.9.9 1.7 3.9 1.3 6.6.7-4 1.8-7 3-8.5 1.2-1.6 3-5.7 2.4-9.1 1 .1 2.3 6.2 1.8 15.1.4-.5.8-.9 1.2-1.1.9-.4 2.4-2.2 2.4-4.9.5.5.7 3.8.2 8.1.7-.9 1.5-1.6 2.2-2.7 2.8-4.3 3-6 3.5-10.6.1-1.1.8-1.3 1-.6 1 3.7 1 8.2-.3 13.4-.6 2.3-1.2 4.3-1.9 6 .3 0 .5.1.8.1.5-.6 1-1.1 1.4-1.8 1.8-2.7 1.9-3.8 2.2-6.7.1-.7.5-.8.6-.4.6 2.3.6 5.2-.2 8.4-.1.3-.2.6-.2.9 20.7 2.7 36.3 7.4 52.5 13.3-3.3-.2-6.6 0-9.9.3zm-118.9-13.1c0-.4-.1-.9-.1-1.3-.2.8-.5 1.6-.7 2.2l.5-.1c.1-.3.2-.5.3-.8z"
            />
            <ellipse
              cx="926.3"
              cy="573.6"
              fill="#55A32A"
              opacity="0.5"
              rx="123.8"
              ry="43"
            />
            <path
              fill="#68C902"
              d="M834.5 630.8c-6.9-1.3-13.8-2.9-20.6-4.7l-5.1-1.4-4.8-1.4c-2.7-.8-4.1-.9-3.7-.9 0-.6-.1-1.3-.2-2 0-.3 0-.7.1-1 0-.5-.1-.6-.1-.3 0-.4-.3-3.1-.4-4.9-.1-1.8-.1-3-.2-3.5.1.1.2.9.2 1.8-.1-1.3-.1-2.3-.1-3 0-.6 0-2.1-.1-3.1.1-.2.4 3.1.5 7.8v-1.5.2c0-2.9.1-4.8.1-5.9.2.6.3 2.9.2 4.9.1-3.1.3-5.3.5-6.6.2-1.2.7-4.4.7-7 .3 0 .3 4.7-.3 11.4.1-.4.2-.7.2-.9.1-.3.5-1.7.7-3.7.1.4-.2 2.8-.6 6.1.2-.7.3-1.3.5-2.1.9-3.3 1.1-4.6 1.7-8.1.1-.8.3-1 .3-.5-.1.8-.1 1.7-.3 2.7.1.4 0 2-.3 3.7.5-2.6 1-4.7 1.4-5.9.4-1.2 1.3-4.1 1.5-6.1.2-.1.1 1.5-.3 4.3s-1.3 6.8-2.4 11.5c.5-2 .9-2.6 1-2.9 0 .1 0 .2-.1.3 1.6-5.6 2.9-9.4 3.3-11.5.2 1.4-.6 5.9-1.7 9.9 1.8-6 3.4-10.4 4.6-12.6 1.2-2.3 3.7-8.3 4.8-13.5.5.2-1.3 9.4-5.2 22.6.4-.8.7-1.3 1-1.6.6-.6 2-3.1 3.1-7.2 0 .8-1.2 5.7-3.2 12 .7-1.4 1.3-2.4 2.1-3.9 3-6.4 3.7-8.9 5.8-15.8.5-1.6.9-2 .7-.9-1 5.5-2.7 12.3-5.3 19.9-1.2 3.6-2.3 6.7-3.3 9.1l.4.1v-.1c.5-1 .9-1.6 1.4-2.7 1.9-4 2.3-5.6 3.6-9.9.3-1 .6-1.3.4-.6-.6 3.5-1.7 7.7-3.3 12.6-.1.4-.2.7-.3 1l1.2.3c.1-.3.2-.6.3-.8.7-2.3 1.3-3.8 1.4-4.4.1.2-.1 1.3-.4 2.4.5-1.7.9-2.9 1.3-3.7.3-.8 1-2.6 1.2-3.9.2-.2-.5 4.1-2.3 10.1.4-1.3.7-1.7.8-1.9 0 .1 0 .1-.1.2 1.2-3.6 2.1-6 2.4-7.4.1.9-.4 3.8-1.2 6.4 1.2-3.9 2.2-6.7 2.9-8.2.7-1.5 2.2-5.4 2.8-8.8.1 0-.1 1.6-.6 4.1-.5 2.6-1.3 6.2-2.4 10.6.2-.5.4-.9.6-1 .4-.4 1.2-2.1 1.8-4.7 0 .5-.6 3.7-1.7 7.9.4-.9.8-1.6 1.3-2.6 1.8-4.2 2.2-5.8 3.4-10.3.3-1.1.5-1.3.4-.6-.5 3.6-1.5 8-3 13-.7 2.3-1.3 4.2-1.9 5.8l.2.1c.3-.6.5-1 .8-1.7 1.1-2.6 1.4-3.7 2.1-6.5.2-.7.3-.8.3-.4-.3 2.3-.9 5-1.8 8.2l-.3.9c5.9 2.7 10.2 6.5 14.9 11-1 .7-2.2 1.2-3.3 1.7zm-32.8-15.2c.1-.4.1-.9.2-1.3-.2.8-.3 1.5-.4 2.1l.1-.1c0-.2 0-.5.1-.7z"
            />
            <path
              fill="#C08330"
              d="M997.9 526.3L1091.6 599.9 1068.9 610.5 988.1 536z"
            />
            <path
              fill="#9B5630"
              d="M1068.9 610.5L1068.9 623.3 987.3 548.8 986.9 534.6z"
            />
            <path
              fill="#753E29"
              d="M1091.6 599.9L1092.7 610.7 1068.9 623.3 1068.9 610.5z"
            />
            <path
              fill="#753E29"
              d="M809.8 401.8s17.2-33.8 62.3-38.1 75.2 29.6 75.2 29.6l58 80.4-4.1 63.8-3.7 2.1-3.3 4.1L870 592.1l-64.5-175.5 4.3-14.8z"
            />
            <path
              fill="#9B5630"
              d="M809.8 520.2L805.5 416.6 870 482.1 870 592.1z"
            />
            <path
              fill="#6D2D26"
              d="M959.5 390.7L960.1 476 1002 537 1003 536 1004.4 534.8 1014.5 473.1z"
            />
            <path
              fill="#602D26"
              d="M948.8 397.5L952.5 480.7 994.4 543.7 1006.8 477.9z"
            />
            <path
              fill="#C08330"
              d="M959 389.9L948.8 397.5 997 471.7 1015.4 468.4z"
            />
            <path
              fill="#C08330"
              d="M805.5 416.6s9.5-41.5 65.1-44.8c55.5-3.3 78.2 25.8 78.2 25.8l10.7-6.8s-41.6-46-109.9-31.8-60.1 63.5-60.1 63.5l16-5.9z"
            />
            <path
              fill="#C08330"
              d="M994.4 543.7L1006.3 533.1 1015.4 468.4 997 471.7z"
            />
            <path
              fill="#9B5630"
              d="M797.9 530.8L789.4 421.5 849.8 488.3 858.1 602.7z"
            />
            <path
              fill="#753E29"
              d="M962.4 653.8L963.5 664.6 939.7 677.2 939.7 664.4z"
            />
            <ellipse
              cx="813.1"
              cy="533.8"
              fill="none"
              stroke="#753E29"
              strokeMiterlimit="10"
              strokeWidth="9"
              rx="23.5"
              ry="62.7"
            />
            <ellipse
              cx="810.8"
              cy="533.8"
              fill="none"
              stroke="#753E29"
              strokeMiterlimit="10"
              strokeWidth="9"
              rx="6.3"
              ry="22.8"
            />
            <path
              fill="none"
              stroke="#753E29"
              strokeMiterlimit="10"
              strokeWidth="9"
              d="M813.1 471.1L811.3 598.8"
            />
            <path
              fill="none"
              stroke="#753E29"
              strokeMiterlimit="10"
              strokeWidth="9"
              d="M833.9 501.8L792 568.3"
            />
            <path
              fill="none"
              stroke="#753E29"
              strokeMiterlimit="10"
              strokeWidth="9"
              d="M795 496.2L829.4 576.9"
            />
            <path
              fill="none"
              stroke="#753E29"
              strokeMiterlimit="10"
              strokeWidth="9"
              d="M791.7 524.5L833.5 549.3"
            />
            <path
              fill="#C08330"
              d="M876.6 590.6L994.4 543.7 995.8 523 863.8 573.9z"
            />
            <path
              fill="#FFF"
              d="M869.1 545.7c4 9.7 6 14.1 19.6 14.9 13.6.7 27.2-7.4 37-8.2 9.8-.7 32.5-7.4 37.8-16.4 5.3-8.9 3-26.8-5.3-34.2s-49.9-11.9-65.7 3.7c-15.9 15.6-30.2 23.8-23.4 40.2z"
            />
            <path
              fill="#DEE4FF"
              d="M884.5 536.8c3.3 5.1 5 7.4 16.1 7.8 11.2.4 22.3-3.9 30.4-4.3 8.1-.4 26.6-3.9 31-8.5 4.3-4.7 2.5-14-4.3-17.8-6.8-3.9-40.9-6.2-53.9 1.9-13.1 8.1-24.9 12.3-19.3 20.9z"
            />
            <path
              fill="#FFF"
              d="M943.1 503.3c9.1-11.9 11.3-26.8-6.8-40.9-18.1-14.1-40-31.2-51.4-19.3-11.3 11.9-36.3 12.6-30.2 36.4 6 23.8 7.2 43 31.7 37.9s56.7-14.1 56.7-14.1z"
            />
            <path
              fill="#DEE4FF"
              d="M944.6 502.2c9.1-11.9 11.3-26.8-6.8-40.9-18.1-14.1-40-31.2-51.4-19.3s-36.3 7.6-30.2 31.4c6 23.8 48 5.4 63.1-3.3 7 2.5 25.3 32.1 25.3 32.1z"
            />
            <path
              fill="#FFF"
              d="M915.2 479.5c17.4-11.9 31.7-28.2 52.9-13.4 21.2 14.9 34 31.2 31.7 43.1-2.3 11.9-17 18.9-32.8 24.9-27.8-14.7-42 .4-45.7-5.5-3.9-6-6.1-49.1-6.1-49.1z"
            />
            <path
              fill="#FFF"
              d="M907.6 436c19.6 17.8 39.3 41.2 50.6 33.1 11.3-8.2 15.9-20.1 3.8-44.6-12.1-24.5-37-41.6-49.9-37.9-12.8 3.7-24.2 9.7-28.7 27.5-4.5 17.9 24.2 21.9 24.2 21.9z"
            />
            <path
              fill="#DEE4FF"
              d="M935.2 417.8c19.6 17.8 12.5 59.8 23.8 51.7 11.3-8.2 15.9-20.1 3.8-44.6-12.1-24.5-37-41.6-49.9-37.9s-16.2 6.8-.8 17.1c15.1 10 23.1 13.7 23.1 13.7zM901.6 425.3c1.4-23.9-18.9-37.2-31.7-32.7s-31 3-35.5 16.4c-4.5 13.4-15.9 18-14.4 21.7 1.5 3.7 40.8 42.9 40.8 42.9s40-35 40.8-48.3z"
            />
            <path
              fill="#C08330"
              d="M805.5 416.6L789.4 421.5 849.6 489 870 482.1z"
            />
            <path
              fill="#C08330"
              d="M857.5 600.9L870 592.1 870 482.1 849.8 488.3z"
            />
            <path
              fill="#C08330"
              d="M868.7 580.2L962.4 653.8 961.5 655.9 954.9 659.3 950.4 659.8 949.3 662.3 940.9 666.1 939.7 664.4 856.8 589.3z"
            />
            <path
              fill="#9B5630"
              d="M939.7 664.4L939.7 677.2 856.7 601 856.6 588.3z"
            />
            <path
              fill="#9B5630"
              d="M859.2 586.5L869.4 583.2 867.9 557 866.6 581.2z"
            />
            <path
              fill="#9B5630"
              d="M858.3 577.8L857 565.6 856.7 532.6 859.1 563.1z"
            />
            <path
              fill="#9B5630"
              d="M850.9 487.1L858.1 484.5 860 488.1 860.2 482.7 866.2 481.2 867 484.5 870 482.1 864.5 479.7 854.3 482.3 856.4 483.2 851.5 484.9 841.7 477.7z"
            />
            <path fill="#9B5630" d="M860.8 491.4L862.1 527.1 862.6 505.1z" />
            <path fill="#9B5630" d="M866.9 485.7L868.2 499.7 868 489.2z" />
            <path fill="#9B5630" d="M858.3 585.2L858.4 579.1 860.8 582z" />
            <path
              fill="#9B5630"
              d="M800.6 389.3s-6.3 13.1-6.3 13.7-1.7 14.3-1.7 14.3l3.4-15.1 4.6-12.9zM799.6 400.9c.6-2.2 3.8-13.9 7.7-16.2 4-2.2 5.1 6.5 5.1 6.5s-1.5-5.9-4.3-4.5c-2.9 1.6-8.5 14.2-8.5 14.2z"
            />
            <path
              fill="#9B5630"
              d="M803.2 417.1L800.1 414.3 803.2 420.4 818.5 436z"
            />
            <path
              fill="#9B5630"
              d="M823.1 452.4c1.6 1.4 11 12.7 15 17.4s7.9 8.6 12.5 7.7c4.5-1-.3-7.8-.3-7.8s3.5 7.2-.8 6.1c-4.4-1.1-9.3-5.6-13-9.8-3.7-4.1-13.4-13.6-13.4-13.6z"
            />
            <path
              fill="#9B5630"
              d="M841.4 467.9c-3.7-4.5-7.1-10.3-2.3-9.8s9.1 7.9 9.1 7.9-7.9-7.8-9.1-6.7c-1.1 1.2 2.3 8.6 2.3 8.6zM913.7 634.6c1.6 1.3 11.4 12.3 15.6 16.9 4.1 4.6 8.2 8.4 12.7 7.3 4.5-1.1-.5-7.8-.5-7.8s3.8 7.1-.7 6.2c-4.4-1-9.5-5.3-13.3-9.3-3.9-4.2-13.8-13.3-13.8-13.3z"
            />
            <path
              fill="#9B5630"
              d="M932.5 649.5c-3.8-4.3-7.4-10.1-2.6-9.7 4.8.4 9.3 7.7 9.3 7.7s-8.2-7.6-9.3-6.4c-1.1 1.1 2.6 8.4 2.6 8.4z"
            />
            <path
              fill="#9B5630"
              d="M862.1 589.2L873.1 600.6 887.3 611.4 873.9 598.6 871.6 594.1z"
            />
            <path
              fill="#9B5630"
              d="M891.7 615.5L898.9 619.1 903.8 627.6 896.8 619.7z"
            />
            <path
              fill="#9B5630"
              d="M879.8 588.6L871.9 583.2 871.5 573.2 875.1 581.5z"
            />
            <path
              fill="#9B5630"
              d="M876.6 573.4L886.8 567.4 899.3 565.4 908.5 560 899.5 568.9 886.6 569.3z"
            />
            <path
              fill="#9B5630"
              d="M882.3 584.5L886.4 580.2 894 580 904.8 574.1 891.9 582.8z"
            />
            <path fill="#9B5630" d="M852.1 490.1l1.7 19.7s1.2-15.1-1.7-19.7z" />
            <path fill="#9B5630" d="M867.7 553.3L867.6 534.1 866.3 544.9z" />
            <path
              fill="#9B5630"
              d="M867.9 501.9L866.6 509.3 868.5 514.8 868.7 523.4 869.4 513.3 867.4 508.7z"
            />
            <path
              fill="#9B5630"
              d="M860.4 576.5L860.9 567.4 859.8 559.3 862.9 568.1z"
            />
            <path
              fill="#9B5630"
              d="M855 523.4L853.6 515.4 855.1 510.6 855.1 515.8z"
            />
            <path
              fill="#9B5630"
              d="M805.3 433.1L811.5 442.3 819.9 449.2 812.3 440.5z"
            />
            <path
              fill="#9B5630"
              d="M792.8 419.4L792.1 421.9 801.6 431.3 793.8 421.7z"
            />
            <path
              fill="#9B5630"
              d="M804.7 407.3c3.4-3.6 6.1-12.5 5.5-14.5s-4-2.6-6.4 3.2c3.1-4.1 5.3-3.2 4.7.4-.7 4.6-3.8 10.9-3.8 10.9z"
            />
            <path
              fill="#9B5630"
              d="M879.6 359.5L884.2 358.4 894.9 360.3 883.7 359.8z"
            />
            <path
              fill="#9B5630"
              d="M882.8 366.6L886.6 370.1 892.5 368.6 894.9 368.5 891.3 367.2 886.6 368.3z"
            />
            <path
              fill="#9B5630"
              d="M956.8 402.7L958.3 406.5 966.7 414.3 959.4 405.2z"
            />
            <path
              fill="#9B5630"
              d="M961.9 396.4L962.8 403.7 970 411.2 975 416.7 970.6 409.8 964 402.8z"
            />
            <path
              fill="#9B5630"
              d="M997.6 464.6l.3-2.9 4.5-.3 1.1.8 2.7-1.8-5.9-3.8-2.8 2.8c-.1 0-1.6 1.5.1 5.2z"
            />
            <path
              fill="#9B5630"
              d="M882.1 596.4L891.9 601.2 906.1 615.2 889.8 602.7z"
            />
            <path
              fill="#9B5630"
              d="M906.8 620.9L911.8 629.5 924.4 637.3 912.5 627.6z"
            />
            <path
              fill="#9B5630"
              d="M914.8 620.2L934.6 635 947.4 646.8 931.8 635z"
            />
            <path
              fill="#9B5630"
              d="M913.8 566.9L926.5 556.6 967.8 547 927 559z"
            />
            <path
              fill="#9B5630"
              d="M913.6 570.9L928.9 565.7 955.6 554.8 928.9 567.7z"
            />
            <path
              fill="#68C902"
              d="M820.1 630.3c-13-2.3-26-4.9-38.9-7.8-.8-.8-1.6-1.7-2.4-2.6.5-.2 1.1-.4 1.6-.7 0-.5 0-.7-.2-.4.1-.4.5-3.1 1-4.8.5-1.7.8-2.9.9-3.4.1.2 0 1-.2 1.8.3-1.3.6-2.3.8-2.8.2-.6.7-2 .8-3 .2-.1-.3 3.1-1.5 7.7.3-1 .5-1.3.5-1.4v.2c.8-2.8 1.4-4.6 1.6-5.7.1.7-.2 2.9-.7 4.9.8-3 1.5-5.1 2-6.3.5-1.2 1.5-4.2 2-6.7.1 0 0 1.2-.3 3.2s-.9 4.8-1.6 8.1c.2-.4.3-.7.4-.8.3-.3.9-1.6 1.3-3.6 0 .4-.4 2.8-1.2 6 .3-.7.6-1.2.9-2 1.3-3.2 1.6-4.5 2.4-7.9.2-.8.4-1 .3-.5-.1.8-.2 1.7-.4 2.7.1.4-.1 2-.4 3.6.6-2.6 1.2-4.6 1.7-5.8.4-1.2 1.3-4.1 1.6-6 .3-.3-.6 6.4-2.9 15.7.6-2 .9-2.6 1.1-2.9 0 .1 0 .2-.1.3 1.6-5.6 2.8-9.5 3.1-11.5.1 1.4-.4 5.9-1.4 9.9 1.6-6.1 3-10.5 3.9-12.8 1-2.4 3-8.5 3.8-13.8.2 0 0 2.4-.6 6.4s-1.7 9.7-3.1 16.4c.3-.8.6-1.4.8-1.6.5-.6 1.7-3.3 2.5-7.4.1.7-.8 5.7-2.3 12.2.6-1.4 1.1-2.5 1.8-4.1 2.5-6.6 3.1-9.1 4.6-16.1.4-1.7.7-2.1.6-.9-.6 5.6-1.9 12.5-3.9 20.3-1 3.7-1.9 6.8-2.7 9.3h.4v-.1c.4-1 .8-1.7 1.2-2.8 1.6-4.1 1.9-5.7 2.9-10.1.2-1.1.5-1.3.4-.6-.4 3.5-1.2 7.8-2.4 12.7-.1.4-.2.7-.3 1 .4.1.8.1 1.2.2.1-.3.1-.6.2-.9.6-2.3 1-3.9 1.1-4.5.1.2 0 1.3-.2 2.4.4-1.7.7-3 1-3.8.3-.8.8-2.7 1-3.9.2-.2-.3 4.1-1.7 10.2.3-1.3.6-1.7.7-1.9v.2c1-3.7 1.7-6.1 1.9-7.5.1.9-.2 3.8-.8 6.4.9-3.9 1.8-6.8 2.4-8.3.6-1.5 1.9-5.5 2.3-8.9.1 0 0 1.6-.3 4.2-.4 2.6-1 6.3-1.8 10.7.2-.5.4-.9.5-1.1.3-.4 1.1-2.1 1.6-4.8.1.5-.4 3.7-1.3 7.9.4-.9.7-1.6 1.1-2.7 1.6-4.3 1.9-5.9 2.9-10.5.2-1.1.5-1.3.4-.6-.3 3.6-1.1 8.1-2.4 13.1-.6 2.3-1.1 4.3-1.6 5.9l.2.1c.3-.6.5-1.1.7-1.8 1-2.7 1.2-3.7 1.8-6.6.1-.7.3-.8.3-.4-.2 2.3-.7 5.1-1.5 8.3-.1.3-.1.6-.2.9 5.8 2.3 10 6 14.4 10.5-1.1.7-2.2 1.2-3.3 1.7zm-33.8-13.8c.1-.4.2-.9.3-1.3-.2.8-.5 1.5-.7 2.1l.2-.1c0-.3.1-.5.2-.7z"
            />
            <path
              fill="#68C902"
              d="M838.4 631.1l-50-16.6c-1-1-2.1-2.1-3.1-3.2.7-.1 1.4-.2 2.1-.4 0-.5 0-.7-.2-.4.1-.4.8-3 1.5-4.7.7-1.7 1.2-2.8 1.3-3.3.1.2-.1 1-.3 1.8.4-1.2.9-2.2 1.2-2.7.3-.6.9-1.9 1.1-2.9.2-.1-.5 3.1-2.1 7.6.4-.9.6-1.2.8-1.3 0 0 0 .1-.1.2 1.2-2.6 2-4.4 2.2-5.4.1.7-.4 2.9-1.1 4.8 1.1-2.9 2.1-4.9 2.8-6 .7-1.1 2.2-3.9 2.8-6.5.3.1-.7 4.6-2.9 11 .2-.4.4-.6.6-.7.4-.3 1.2-1.4 1.8-3.4 0 .4-.6 2.8-1.7 5.9.4-.6.8-1.1 1.2-1.8 1.8-3 2.2-4.2 3.4-7.5.3-.8.5-.9.4-.4-.2.8-.4 1.7-.6 2.7.1.4-.1 2-.7 3.6.9-2.5 1.8-4.4 2.4-5.6.6-1.1 1.9-3.9 2.3-5.8.4-.2-.9 6.4-4.3 15.4.8-1.9 1.3-2.5 1.5-2.7 0 .1-.1.2-.1.3 2.4-5.4 4-9 4.6-11.1.1 1.4-.8 5.9-2.2 9.8 2.3-5.8 4.3-10 5.7-12.2 1.4-2.2 4.4-8 5.6-13.1.6.2-1.5 9.4-5.8 22.5.5-.7.9-1.2 1.2-1.5.7-.5 2.5-2.9 3.7-6.9.1.8-1.3 5.7-3.5 11.9.9-1.3 1.6-2.2 2.5-3.7 3.7-6.1 4.5-8.6 6.9-15.3.6-1.6 1.1-1.9.9-.8-1 5.6-3.1 12.2-6.2 19.7-1.5 3.5-2.8 6.5-4 8.9.2 0 .3.1.5.1v-.1c.6-.9 1.1-1.5 1.7-2.6 2.3-3.8 2.8-5.4 4.4-9.6.4-1 .7-1.2.6-.5-.7 3.5-1.9 7.7-3.9 12.4-.1.3-.3.7-.4 1 .5.1 1 .3 1.6.4.1-.3.2-.6.3-.8.9-2.2 1.5-3.7 1.7-4.3.1.2-.1 1.3-.4 2.4.6-1.6 1.1-2.9 1.5-3.6.4-.7 1.2-2.5 1.5-3.8.3-.1-.6 4.1-2.8 10 .5-1.2.8-1.6 1-1.8 0 .1 0 .1-.1.2 1.5-3.5 2.6-5.8 2.9-7.2.1.9-.5 3.8-1.4 6.4 1.5-3.8 2.8-6.5 3.7-7.9.9-1.4 2.8-5.2 3.6-8.5.4.1-1 6.1-3.8 14.5.3-.5.6-.8.8-.9.5-.3 1.6-1.9 2.4-4.5.1.5-.8 3.7-2.3 7.7.6-.8 1.1-1.4 1.6-2.4 2.4-4 2.9-5.5 4.5-9.9.4-1 .7-1.2.6-.5-.7 3.6-2 7.9-4 12.7-.9 2.2-1.7 4.1-2.5 5.6.1 0 .2.1.3.1.4-.6.7-1 1.1-1.6 1.5-2.5 1.8-3.5 2.8-6.2.2-.7.4-.8.4-.3-.4 2.3-1.3 5-2.5 8-.1.3-.2.6-.4.8 7.5 3.8 12.6 8.5 17.9 14.1-1.6-.1-3.1.2-4.5.4zm-43.3-21.8c.1-.4.3-.8.4-1.3l-1 2h.2c.2-.2.3-.5.4-.7z"
            />
            <path
              fill="#68C902"
              d="M897.9 667.2c-1.3-1.7-3.8-3.8-7.6-6.2-3.7-2.3-8.4-4.8-13.7-7.7-10.4-5.7-20.7-11.8-30.7-18.2-1.1-1.5-2.3-3-3.4-4.6l2.7.6c.1-.5.1-.7-.2-.5.2-.3 1.5-2.8 2.6-4.2 1.1-1.4 1.9-2.4 2.1-2.8.1.2-.2 1-.7 1.7.8-1.1 1.4-1.9 1.9-2.3.5-.4 1.5-1.6 1.8-2.5.3 0-1.1 3-3.8 6.9.6-.8 1-1 1.1-1.1l-.1.1c1.8-2.2 3.1-3.7 3.6-4.7 0 .7-.9 2.8-2.1 4.5 1.8-2.5 3.4-4.2 4.4-5 1-.8 3.2-3.2 4.4-5.5.3.2-1.6 4.4-5.2 10.1.3-.3.6-.4.8-.5.5-.1 1.7-1 2.7-2.8 0 .4-1.2 2.6-3 5.3.6-.5 1.1-.8 1.8-1.4 2.7-2.4 3.4-3.4 5.3-6.4.5-.7.8-.8.6-.2-.3.8-.7 1.6-1.1 2.5.1.5-.5 2-1.4 3.4 1.5-2.2 2.8-3.9 3.7-4.8.9-.9 2.9-3.2 3.7-5.1.5 0-2.1 6.2-7.5 14.1 1.3-1.6 1.9-2 2.3-2.2-.1.1-.1.2-.2.3 3.7-4.6 6.2-7.7 7.1-9.6 0 1.5-1.8 5.8-4.1 9.2 3.6-5.1 6.6-8.7 8.6-10.4 2-1.7 6.4-6.6 8.6-11.5.6.4-3.1 9.1-10.1 20.9.7-.6 1.2-1 1.6-1.1.9-.3 3.4-2.2 5.3-5.8 0 .8-2.3 5.4-5.8 11 1.2-1 2.3-1.7 3.6-3 5.2-5 6.5-7.3 10.2-13.4.9-1.5 1.6-1.6 1.2-.5-1.9 5.3-5.2 11.5-9.8 18.2-2.2 3.2-4.2 5.7-5.9 7.8l.6.3.1-.1c.9-.8 1.5-1.2 2.4-2 3.3-3.2 4.1-4.6 6.4-8.5.6-.9 1-1 .7-.3-1.2 3.4-3.2 7.3-6.1 11.5l-.6.9c.6.3 1.3.6 1.9 1 .2-.3.3-.5.5-.8 1.3-2 2.3-3.3 2.5-3.9.1.3-.2 1.3-.8 2.3.9-1.5 1.7-2.6 2.3-3.2.6-.6 1.8-2.2 2.2-3.4.3 0-1.2 4-4.4 9.4.8-1.1 1.2-1.4 1.4-1.5 0 .1-.1.1-.1.2 2.2-3.1 3.8-5.2 4.3-6.4 0 1-1 3.8-2.4 6.1 2.2-3.4 4-5.8 5.3-7 1.3-1.2 4-4.4 5.3-7.6.4.2-1.7 6-6 13.8.4-.4.8-.6 1-.7.6-.2 2.1-1.5 3.3-3.9 0 .5-1.4 3.5-3.5 7.2.8-.7 1.4-1.2 2.2-2 3.3-3.3 4.1-4.8 6.5-8.8.6-1 1-1 .8-.3-1.2 3.5-3.3 7.5-6.2 11.8-1.3 2-2.5 3.6-3.6 4.9l.3.2c.5-.5.9-.8 1.5-1.3 2.1-2.1 2.6-3 4.1-5.5.4-.6.6-.7.5-.2-.8 2.2-2.1 4.7-4 7.4-.2.3-.4.5-.5.7 2 1.5 3.7 3 5.1 4.5 1.4 1.5 2.5 3.1 3.3 4.6.8 1.5 1.2 3 1.4 4.4.1 1.4 0 2.7-.4 3.8-.5-.1-.9-.2-1.4-.2-.4.1-.7 0-1.2 0zm-42.8-34.5c.2-.4.4-.8.7-1.2-.5.6-1 1.2-1.5 1.6l.3.1c.2-.1.4-.3.5-.5zM959.3 695.5l-15.4.1h-15.8l-1-.1-1.1-.1c-.9-.3-2-.6-3.2-1.1-1.3-.5-2.7-1.1-4.4-2.1-1.8-1-3.7-2.5-5.7-4.6-2-2.1-3.6-4.9-4.6-7.7 1.2 2.6 3.1 5 5.1 6.7 2 1.7 4 2.8 5.7 3.5-.4-.7-.9-1.2-1.7-1.3 0-.2.2-1.1.5-2 .4-.9.9-1.9 1.7-2.5 1.5-1.2 2.5-2 2.6-2.5.3.3.4 1.3-.1 2 .8-1.1 1.5-1.9 2-2.3.6-.4 1.4-1.7 1.5-2.7.2 0 .1.8-.1 2.2-.2 1.4-.6 3.3-1.5 5.5.5-.9 1-1.1 1.2-1.2v.2c1.3-2.6 1.9-4.5 2-5.6.3.7.4 3 0 5 .7-3 1.3-5.2 1.6-6.4.4-1.2.8-4.4.7-7 0 0 .1.3.1.8s.1 1.3.1 2.3c.1 2 .1 4.8.1 8.2.1-.4.1-.7.2-.9.2-.4.4-1.7.4-3.8.1.4.1 2.8.1 6.1.1-.7.2-1.3.4-2.1.5-3.4.5-4.7.5-8.2 0-.8.1-1.1.2-.5.1.8.1 1.7.1 2.7.1.3.3 1.9.3 3.7.1-2.7.2-4.8.3-6 .1-1.3.4-4.3.2-6.2.2-.3.6 6.3.4 16 .1-2.1.3-2.7.4-3.1v.4c.3-5.8.6-9.8.5-12 .3 1.3.6 5.8.5 10 .2-6.3.6-10.9.9-13.4.4-2.5 1-9 .7-14.3.2 0 .4 2.4.6 6.4.2 4.1.3 9.9.3 16.7.1-.9.3-1.5.4-1.8.3-.7.8-3.6.7-7.7.2.7.3 5.8.2 12.4.2-1.5.5-2.6.7-4.4.9-7 .9-9.6 1-16.7 0-1.7.3-2.2.3-1 .4 5.6.5 12.6.2 20.6-.1 3.8-.3 7-.6 9.7l.3-.1v-.1c.2-1.1.3-1.8.5-3 .6-4.4.6-6 .6-10.5 0-1.1.2-1.4.2-.7.3 3.5.3 7.9.2 13v1.1c.3 0 .6-.1.9-.1v-.9c.1-2.4.2-4 .1-4.6.1.2.2 1.2.2 2.4 0-1.7.1-3.1.2-3.9.1-.8.2-2.8.1-4 .1-.2.4 4.1.3 10.3.1-1.3.2-1.8.2-2v.2c.2-3.8.3-6.4.3-7.7.2.8.4 3.8.4 6.5.1-4 .3-7 .6-8.7.2-1.6.6-5.8.4-9.2.1 0 .3 1.5.4 4.2.1 2.6.2 6.4.2 10.8.1-.6.2-.9.2-1.1.2-.5.5-2.3.5-5 .1.5.2 3.7.2 8 .1-1 .3-1.7.4-2.8.6-4.5.6-6.2.6-10.8 0-1.1.2-1.4.2-.7.3 3.6.4 8.1.2 13.3-.1 2.4-.2 4.4-.3 6.1h.2c.1-.7.2-1.1.3-1.9.3-2.8.3-3.9.4-6.8 0-.7.1-.9.1-.4.2 2.3.3 5.1.1 8.4v.9c4.8 1.2 8.5 4.1 12.5 7.7-.4.9-1.2 1.6-1.9 2.2zm-27.9-6.8v-1.3c-.1.8-.1 1.6-.2 2.2l.1-.1c0-.3 0-.6.1-.8z"
            />
            <path
              fill="#9B5630"
              d="M1009.9 539.2L1019.4 550 1034.2 558.8 1020.1 548.3z"
            />
            <path
              fill="#9B5630"
              d="M1018 557.8L1029.6 565.4 1044.6 583.4 1027.1 566.6z"
            />
            <path
              fill="#9B5630"
              d="M1001.5 541.5L1006.2 545.6 1013.7 554.1 1007.6 543.7z"
            />
            <path
              fill="#9B5630"
              d="M1047.9 572.5s36 22.4 32.8 26.3-11.2 3.2-13.7 0c5 1.2 7.2.7 7.5-2.1.3-2.7-26.6-24.2-26.6-24.2z"
            />
            <path
              fill="#9B5630"
              d="M1032.6 561.3L1039.8 568.4 1047.9 572.5 1039.8 565.6z"
            />
            <path
              fill="#9B5630"
              d="M965.7 540.8L972.9 535.6 995.8 530.6 974.5 532.6z"
            />
            <path
              fill="#9B5630"
              d="M966.3 543.7L973.1 540.8 986.9 539.6 973.2 542.3 967.3 544.6z"
            />
            <path fill="#9B5630" d="M1010.9 469.3L1006.2 509.8 1013.7 468.6z" />
            <path
              fill="#9B5630"
              d="M1000 471.2L998.6 477.7 1000 493.6 1000 477.7z"
            />
            <path fill="#9B5630" d="M1004.5 512.4L1003.2 534.1 1005.4 521.9z" />
            <path
              fill="#9B5630"
              d="M1004 498.5L1003.4 506.1 1001.5 520.9 1001.8 504.4z"
            />
            <path
              fill="#DEE4FF"
              d="M943 480.1c1.8 2.3 40 13.7 43.9 11.3s-2.4-9.3-2.4-9.3-5.2 2.9-7.9 2.4c-2.7-.4-33.6-4.4-33.6-4.4z"
            />
            <g fill="#FFF">
              <path d="M847.3 687.9c.3 0 .5.1.7.2.1.1.2.3.2.5 0 .3.1.5.1.8 0 .4 0 .7-.1 1.1 0 .2-.1.3-.2.4s-.2.1-.4.1-.6 0-1.1-.1c-.5-.1-1.1-.1-1.7-.1 0 .6-.1 1.1-.1 1.7v3.8c0 .7.1 1.2.1 1.7s.1.9.1 1.3v.6c0 .2 0 .3-.1.4-.1.1-.2.2-.5.2s-.5.1-.8.1h-1.2c-.2 0-.4-.1-.6-.2-.2-.1-.3-.3-.3-.6-.1-.9-.1-1.8-.2-2.7 0-.9-.1-1.8-.1-2.7v-1.8c0-.6.1-1.2.1-1.9-.6 0-1.2.1-1.6.1-.5 0-.8.1-.9.1-.2 0-.4-.1-.5-.2-.1-.1-.2-.3-.2-.7v-.8c0-.3.1-.5.1-.7.1-.2.2-.3.3-.4.1-.1.3-.1.5-.2.7 0 1.4-.1 2.1-.1h4.3c.7 0 1.3 0 2 .1z" />
              <path d="M854.9 696.2c-.3.1-.7.2-1.1.3-.4.1-.9.2-1.4.2-.5.1-1 .1-1.5.2s-1 .1-1.5.1c.2.3.5.5.9.7s.8.2 1.2.2c.3 0 .7 0 1.1-.1.4-.1.8-.2 1.1-.4.2-.1.3-.1.4-.1.1 0 .2 0 .2.1s.1.2.1.3c0 .1.1.3.1.4 0 .1.1.3.1.4v.4c0 .2-.1.4-.3.6-.4.3-.9.6-1.5.8-.6.2-1.4.3-2.2.3-.6 0-1.1-.1-1.7-.3-.5-.2-1-.5-1.4-.9-.4-.4-.7-.9-1-1.4-.3-.5-.4-1.2-.4-1.8s.1-1.3.4-1.9c.3-.6.6-1.1 1-1.5.4-.4.9-.7 1.5-1 .6-.2 1.1-.3 1.8-.3.8 0 1.5.1 2.1.4.6.3 1 .7 1.4 1.1.3.4.6.9.7 1.3.1.5.2.9.2 1.2 0 .1 0 .3-.1.4.1.2-.1.3-.2.3zM851 694c-.4 0-.8.1-1.2.4-.4.3-.6.6-.7.9.5 0 1.1-.1 1.7-.1.6 0 1.1-.1 1.6-.3-.1-.3-.3-.6-.6-.7-.3-.1-.5-.2-.8-.2zM861.3 691.5c.3 0 .6 0 .9.1.3 0 .6.1.9.2.3.1.5.2.6.4.1.1.2.4.2.7 0 .2 0 .4.1.5v.5c0 .4 0 .8-.1 1.2 0 .3-.1.4-.2.5-.1.1-.3.1-.5.1-.4 0-.7 0-1-.1-.4-.1-.7-.4-.8-.8 0-.2 0-.3-.1-.5v-.5c-.3 0-.6.1-.9.2-.3.1-.5.3-.8.5-.2.2-.4.4-.5.7-.1.2-.2.5-.2.8 0 .3 0 .5.1.8.1.3.2.5.4.7.2.2.4.3.7.5.3.1.5.2.9.2.2 0 .3 0 .5-.1.2 0 .4-.1.5-.1.2-.1.3-.1.5-.2s.3-.1.4-.2c.1-.1.2-.1.3-.2.1 0 .2-.1.2-.1.2 0 .3.1.4.3.1.1.1.3.2.4.1.1.1.3.2.4 0 .1.1.2.1.3v.2c0 .2-.1.3-.3.5-.2.2-.4.3-.6.4-.2.1-.5.2-.8.3s-.6.2-.9.2c-.3.1-.6.1-.9.1-.7 0-1.4-.1-1.9-.2s-1-.4-1.4-.6c-.4-.3-.7-.5-.9-.9-.2-.3-.4-.7-.5-1-.1-.3-.2-.6-.2-.9s-.1-.6-.1-.8c0-.7.2-1.3.5-1.9.3-.6.7-1.1 1.2-1.5.5-.4 1.1-.7 1.7-1 .7.1 1.4-.1 2.1-.1zM865.7 688.9c0-.3 0-.5.1-.7 0-.2.2-.3.4-.4.1 0 .3-.1.5-.1s.4 0 .6-.1.4 0 .6 0h.5c.2 0 .3 0 .4.1 0 .1.1.2.1.4v4.3c.4-.3.9-.5 1.4-.7.5-.1 1-.2 1.5-.2.3 0 .5 0 .8.1l.9.3c.3.1.5.4.7.8.2.3.3.8.3 1.4v1.1c0 .4 0 .9-.1 1.4 0 .5-.1 1-.1 1.5-.1.5-.1 1.1-.2 1.6 0 .2-.1.4-.2.6-.1.2-.3.3-.6.3h-.7c-.3 0-.6-.1-.8-.1-.4-.1-.6-.3-.6-.8 0-.1 0-.6.1-1.3.1-.8.1-1.8.1-3 0-.3-.1-.5-.2-.7-.1-.2-.3-.3-.5-.3-.6 0-1.2.2-1.9.7 0 .9 0 1.8.1 2.6 0 .8.1 1.5.1 2v.4c0 .2-.1.4-.2.5-.1.1-.4.2-.8.2h-1.2c-.4 0-.6-.1-.7-.2-.1-.1-.2-.4-.2-.6 0-.4-.1-.8-.1-1.3s-.1-1.1-.1-1.7c0-.6-.1-1.2-.1-1.9v-2-1.9c.1-1.1.1-1.7.1-2.3zM875.7 692.7c0-.3 0-.5.1-.7 0-.2.2-.3.4-.4.1 0 .3-.1.5-.1s.4 0 .6-.1h1.1c.2 0 .3 0 .4.1.1.1.1.2.1.3v.5c.4-.3.9-.5 1.4-.7.5-.2 1-.2 1.5-.2.3 0 .5 0 .8.1l.9.3c.3.2.5.4.7.8.2.3.3.8.3 1.4v1.1c0 .4 0 .9-.1 1.4 0 .5-.1 1-.1 1.5-.1.5-.1 1.1-.2 1.6 0 .2-.1.4-.2.6-.1.2-.3.3-.6.3h-.7c-.3 0-.6-.1-.8-.1-.4-.1-.6-.3-.6-.8v-.5c0-.2 0-.5.1-.8 0-.3.1-.7.1-1.2v-1.9c0-.3-.1-.5-.2-.7-.1-.2-.3-.3-.5-.3-.3 0-.6.1-.9.2-.3.1-.7.3-1 .5 0 .8 0 1.5.1 2.3 0 .7.1 1.5.2 2.2v.4c0 .2-.1.4-.2.5-.1.1-.4.2-.8.2h-1.2c-.4 0-.6-.1-.7-.2-.1-.1-.2-.4-.2-.6-.1-.9-.2-1.8-.2-2.8-.1-.9-.1-1.9-.1-2.8v-.6-.8zM891.7 691.7c.2.1.3.1.4.2.1.1.1.2.1.4v.4c.9.2 1.7.7 2.2 1.4s.8 1.5.8 2.5c0 .7-.1 1.3-.4 1.8-.3.5-.6 1-1.1 1.3-.5.4-1 .6-1.5.8-.6.2-1.1.3-1.7.3-.8 0-1.5-.1-2.1-.3-.6-.2-1.2-.5-1.6-.8-.4-.4-.8-.8-1-1.4-.2-.6-.4-1.2-.4-1.9s.1-1.4.4-2 .7-1.1 1.2-1.5c.5-.4 1-.7 1.6-1 .6-.2 1.2-.3 1.8-.3.2 0 .4 0 .7.1.2-.1.4-.1.6 0zm-.5 3.4c-.1 0-.3-.1-.3-.1-.1 0-.2-.1-.2-.2-.1-.1-.1-.2-.1-.3v-.4c-.6.1-1.1.3-1.5.7-.4.4-.6.9-.6 1.6 0 .3.1.5.2.7.1.2.2.4.4.5l.6.3c.2.1.5.1.7.1.2 0 .5 0 .7-.1s.5-.2.7-.3c.2-.1.4-.3.5-.5.1-.2.2-.4.2-.7 0-.3-.1-.6-.3-.8-.4-.3-.7-.4-1-.5zM896.5 688.9c0-.4.1-.7.2-.8.1-.1.2-.2.4-.3.3-.1.6-.1.9-.2.4 0 .7-.1.9-.1.2 0 .3 0 .4.1s.1.3.1.6v4.2c0 .9 0 1.7-.1 2.6 0 .8-.1 1.6-.1 2.4 0 .7-.1 1.4-.1 1.9 0 .3-.1.6-.2.7-.1.2-.3.3-.7.3h-1c-.4 0-.6-.1-.7-.2-.1-.1-.2-.4-.2-.6 0-.5-.1-1.2-.1-2V695c0-1 0-2 .1-3.1 0-1 .1-2 .2-3zM906.9 691.7c.2.1.3.1.4.2.1.1.1.2.1.4v.4c.9.2 1.7.7 2.2 1.4.5.7.8 1.5.8 2.5 0 .7-.1 1.3-.4 1.8-.3.5-.6 1-1.1 1.3-.5.4-1 .6-1.5.8-.6.2-1.1.3-1.7.3-.8 0-1.5-.1-2.1-.3-.6-.2-1.2-.5-1.6-.8-.4-.4-.8-.8-1-1.4-.2-.6-.4-1.2-.4-1.9s.1-1.4.4-2 .7-1.1 1.2-1.5c.5-.4 1-.7 1.6-1 .6-.2 1.2-.3 1.8-.3.2 0 .4 0 .7.1.2-.1.4-.1.6 0zm-.5 3.4c-.1 0-.3-.1-.3-.1-.1 0-.2-.1-.2-.2-.1-.1-.1-.2-.1-.3v-.4c-.6.1-1.1.3-1.5.7-.4.4-.6.9-.6 1.6 0 .3.1.5.2.7.1.2.2.4.4.5l.6.3c.2.1.5.1.7.1.2 0 .5 0 .7-.1s.5-.2.7-.3c.2-.1.4-.3.5-.5.1-.2.2-.4.2-.7 0-.3-.1-.6-.3-.8-.4-.3-.7-.4-1-.5zM920.2 702.8c0 .3-.2.5-.3.7l-.6.6c-.2.2-.5.3-.9.4-.3.1-.7.2-1.1.2-.8 0-1.6-.1-2.3-.2-.7-.1-1.4-.4-2.1-.7-.2-.1-.3-.2-.4-.3-.1-.1-.2-.3-.2-.4 0-.2.1-.4.2-.7.1-.3.2-.6.3-.8.1-.1.1-.2.2-.3.1-.1.2-.1.3-.1.1 0 .3 0 .4.1.6.2 1.1.3 1.6.4.5.1 1.1.1 1.7.1.1-.4.1-.8.2-1.2 0-.4.1-.8.1-1.3-.8.6-1.7.9-2.7.9-.6 0-1.1-.1-1.5-.3-.5-.2-.8-.4-1.1-.8-.3-.3-.6-.7-.7-1.1-.2-.4-.3-.9-.3-1.4 0-.7.1-1.4.4-2 .3-.6.7-1.2 1.2-1.6.5-.5 1-.8 1.6-1.1.6-.3 1.2-.4 1.9-.4h.7c.2 0 .4.1.7.2 0-.2.1-.3.1-.4.1-.1.2-.1.3-.1.2 0 .4 0 .8.1.4 0 .7.1 1 .2.1 0 .3.1.4.1.1 0 .2.1.3.2.1.1.1.2.2.3 0 .1.1.3.1.5 0 .3 0 .7.1 1.2v3.4c0 .6 0 1.3-.1 2s-.1 1.3-.1 1.9c-.3.7-.3 1.2-.4 1.7zm-2.6-5.8v-1-1.8c-.1-.1-.3-.1-.5-.1h-.6c-.4 0-.7.1-1 .2-.3.2-.5.3-.7.6-.2.2-.3.5-.4.7-.1.3-.2.5-.2.7 0 .4.1.8.4 1 .3.3.7.4 1.1.4.7 0 1.3-.3 1.9-.7zM930.5 702.8c0 .3-.1.5-.3.7-.1.2-.3.4-.6.6-.2.2-.5.3-.9.4-.3.1-.7.2-1.1.2-.9 0-1.6-.1-2.3-.2-.7-.1-1.4-.4-2.1-.7-.2-.1-.3-.2-.4-.3-.1-.1-.2-.2-.2-.4 0-.1 0-.2.1-.3 0-.1.1-.3.1-.4.1-.1.1-.3.2-.5s.1-.3.2-.4c.1-.1.2-.2.2-.3.1-.1.2-.1.3-.1h.2c.1 0 .2 0 .2.1.3.1.6.2.8.2.3.1.5.1.7.2.2 0 .5.1.7.1h.8c.1-.8.2-1.6.3-2.5-.5.3-.9.6-1.4.7-.5.2-1 .2-1.6.2-.2 0-.5 0-.8-.1l-.9-.3c-.3-.2-.5-.4-.7-.7-.2-.3-.3-.8-.3-1.3v-1.1c0-.4 0-.9.1-1.3 0-.5.1-1 .1-1.5.1-.5.1-1 .2-1.5 0-.3.2-.5.4-.7.2-.1.5-.2.9-.2h.6c.2 0 .4.1.6.1.4.1.6.4.6.8v.6c0 .3-.1.6-.1 1s-.1.8-.1 1.3v1.4c0 .3.1.5.2.7.1.2.3.3.5.3.3 0 .6-.1 1-.2s.7-.3 1-.5c0-.4 0-.9-.1-1.4 0-.5-.1-.9-.1-1.4 0-.4-.1-.8-.1-1.1v-.5c0-.2.1-.4.2-.6.1-.1.4-.2.7-.3.1 0 .3-.1.5-.1h.5c.3 0 .6 0 .7.1.2.1.3.3.3.6s.1.7.1 1.1c0 .4.1.9.1 1.4 0 .5 0 1 .1 1.6v4.1c0 1-.1 1.7-.1 2.4zM938 700.4c-.2 0-.3-.1-.4-.2-.1-.1-.2-.2-.2-.3v-.4-.3-.7c0-.3.1-.5.1-.7 0-.1.1-.2.1-.3.1-.1.2-.1.3-.1h.2c.1 0 .2 0 .3.1.2 0 .4 0 .6.1h.9c.3 0 .7 0 1-.1.3 0 .7-.1.9-.2.3-.1.5-.2.7-.3.2-.1.3-.3.3-.5s-.2-.3-.5-.4c-.3-.1-.8-.2-1.3-.3-.5-.1-1.1-.2-1.7-.4-.6-.1-1.2-.4-1.7-.6-.5-.3-.9-.6-1.3-1.1-.3-.4-.5-1-.5-1.7s.2-1.4.6-1.9c.4-.5.9-1 1.5-1.3.6-.3 1.3-.6 2.1-.7.8-.2 1.6-.2 2.4-.2h.6c.2 0 .4 0 .6.1l.1-.4c0-.1.1-.2.2-.3.1-.1.2-.1.3-.1.7 0 1.3.1 1.9.3.2.1.3.2.4.3.1.1.1.2.1.3 0 .4 0 .8-.1 1.2 0 .4-.1.7-.1 1 0 .3-.1.6-.1.9 0 .3-.1.6-.1.9 0 .2-.1.3-.2.4-.1.1-.3.2-.5.2h-.9c-.2 0-.5-.1-.8-.1-.1 0-.2-.1-.3-.2-.1-.1-.1-.3-.1-.4v-.4-.4c-.2 0-.5-.1-.7-.1h-.7c-.4 0-.7 0-1.1.1-.3 0-.6.1-.8.2l-.6.3c-.1.1-.2.3-.2.4 0 .2.2.4.5.5.3.1.7.2 1.2.3.5.1 1 .2 1.6.3.6.1 1.1.3 1.6.6s.9.6 1.2 1.1c.3.5.5 1.1.5 1.8s-.2 1.3-.5 1.8-.7 1-1.3 1.3c-.5.4-1.2.6-1.9.8-.7.2-1.5.3-2.4.3-.4-.3-1.1-.4-1.8-.5zM947.8 688.9c0-.4.1-.6.1-.8 0-.1.2-.2.4-.3.1 0 .3-.1.5-.1s.4 0 .6-.1.4 0 .6 0h.5c.2 0 .3 0 .4.1 0 .1.1.2.1.4s0 .9-.1 2c0 1.1-.1 2.7-.1 4.9.5-.7.9-1.3 1.4-1.9.5-.6.9-1.1 1.5-1.7l.3-.3c.1-.1.2-.1.3-.1.2 0 .3 0 .4.1.4.3.8.6 1.1.9.2.2.2.4.2.6 0 .2-.1.4-.3.6-.3.3-.6.7-1 1.1-.4.4-.8.8-1.2 1.1.2 0 .3 0 .5-.1h.8c.1 0 .3 0 .4.1.4.1.7.2.9.5.2.3.2.7.2 1.3 0 .3 0 .7-.1 1.1-.1.4-.1.8-.2 1.2-.1.3-.2.5-.3.6-.1.1-.3.2-.5.2s-.5 0-.8-.1c-.3 0-.6-.1-.9-.2-.1 0-.2-.1-.3-.2-.1-.1-.1-.2-.1-.4v-.1c0-.1 0-.1.1-.2.1-.2.1-.4.1-.7 0-.3.1-.6.1-.9-.1 0-.3 0-.5-.1h-1.4c-.2 0-.5.1-.7.2v.7c0 .2 0 .4.1.6v.8c0 .2-.1.4-.2.5-.1.1-.4.2-.8.2h-1.2c-.4 0-.6-.1-.7-.2-.1-.1-.2-.4-.2-.6 0-.4-.1-.8-.1-1.3s-.1-1.1-.1-1.7c0-.6-.1-1.2-.1-1.9v-2-1.9c.2-.7.3-1.3.3-1.9zM959.3 687.5c.3 0 .6 0 .8.1.2 0 .4.1.6.3.1.1.3.3.3.6.1.2.1.6.1.9 0 .2 0 .4-.1.6-.1.2-.1.4-.3.5-.1.1-.3.3-.6.3-.2.1-.6.1-.9.1-.3 0-.6 0-.8-.1-.2-.1-.4-.1-.5-.3s-.2-.3-.3-.5c-.1-.2-.1-.5-.1-.8 0-.6.1-1 .4-1.3.3-.3.8-.4 1.4-.4zm-1.5 5.4c0-.3 0-.5.1-.7.1-.2.2-.3.4-.3s.4-.1.7-.1H960.4c.2 0 .3.1.3.2s.1.3.1.6v3.6c0 1.1-.1 2.3-.2 3.4v.5c0 .1-.1.2-.1.3-.1.1-.2.1-.3.2-.1 0-.3.1-.5.1-.3 0-.7 0-1-.1-.4 0-.6-.1-.7-.3-.1-.1-.2-.4-.2-.7 0-.4 0-.9-.1-1.3V697v-2c.1-.7.1-1.4.1-2.1zM962.7 688.9c0-.4.1-.7.2-.8.1-.1.2-.2.4-.3.3-.1.6-.1.9-.2.4 0 .7-.1.9-.1.2 0 .3 0 .4.1s.1.3.1.6v4.2c0 .9 0 1.7-.1 2.6 0 .8-.1 1.6-.1 2.4 0 .7-.1 1.4-.1 1.9 0 .3-.1.6-.2.7-.1.2-.3.3-.7.3h-1c-.4 0-.6-.1-.7-.2-.1-.1-.2-.4-.2-.6 0-.5-.1-1.2-.1-2V695c0-1 0-2 .1-3.1 0-1 .1-2 .2-3zM967.4 688.9c0-.4.1-.7.2-.8.1-.1.2-.2.4-.3.3-.1.6-.1.9-.2.4 0 .7-.1.9-.1.2 0 .3 0 .4.1.1.1.1.3.1.6v4.2c0 .9 0 1.7-.1 2.6 0 .8-.1 1.6-.1 2.4 0 .7-.1 1.4-.1 1.9 0 .3-.1.6-.2.7-.1.2-.3.3-.7.3h-1c-.4 0-.6-.1-.7-.2-.1-.1-.2-.4-.2-.6 0-.5-.1-1.2-.1-2V695c0-1 0-2 .1-3.1 0-1 .1-2 .2-3zM978.4 698c0 .4-.1.8-.3 1.1-.2.3-.5.6-.8.8-.4.2-.8.4-1.2.5-.5.1-1 .2-1.6.2-.5 0-.9 0-1.3-.1s-.8-.2-1.1-.3c-.3-.1-.5-.3-.5-.6 0-.1 0-.2.1-.4 0-.2.1-.3.2-.5s.2-.4.2-.5c.1-.2.2-.4.4-.4.1 0 .2 0 .5.1.2.1.5.2.7.2.2 0 .5.1.6.1.3 0 .5 0 .7-.1s.3-.2.3-.3c0-.1-.1-.2-.3-.4-.2-.1-.4-.2-.7-.3-.3-.1-.6-.2-.9-.4-.3-.1-.6-.3-.9-.6-.3-.2-.5-.5-.7-.8-.2-.3-.3-.7-.3-1.1 0-.4.1-.8.3-1.2.2-.3.5-.6.9-.9.4-.2.8-.4 1.3-.6.5-.1 1-.2 1.5-.2.4 0 .9 0 1.3.1s.9.2 1.2.3c.2.1.3.2.4.3.1.1.2.3.2.5 0 .3 0 .5-.1.9-.1.3-.1.6-.2.8-.1.2-.1.3-.2.4-.1.1-.3.2-.5.2-.4 0-.7 0-1.1-.1-.2 0-.4-.1-.5-.2-.1-.1-.1-.3-.1-.5v-.1c-.2-.1-.4-.1-.6-.1-.3 0-.6 0-.8.1-.2.1-.3.2-.3.4 0 .1.1.3.3.4s.5.2.8.3c.3.1.6.2 1 .4.4.1.7.3 1 .6.3.2.6.5.8.8.2.3.3.7.3 1.2z" />
            </g>
          </g>
          {resources && (
            <>
              <ResourceLink
                r={resources[0]}
                svgComponent={resource1SVGComponent}
                onElementHover={(e) =>
                  onElementHover(resources[0], e.target as SVGElement)
                }
                onElementLeave={() => onElementHover()}
                onElementClick={onClick}
              />
              <ResourceLink
                r={resources[1]}
                svgComponent={resource2SVGComponent}
                onElementHover={(e) =>
                  onElementHover(resources[1], e.target as SVGElement)
                }
                onElementLeave={() => onElementHover()}
                onElementClick={onClick}
              />
              <ResourceLink
                r={resources[2]}
                svgComponent={resource3SVGComponent}
                onElementHover={(e) =>
                  onElementHover(resources[2], e.target as SVGElement)
                }
                onElementLeave={() => onElementHover()}
                onElementClick={onClick}
              />
              <ResourceLink
                r={resources[3]}
                svgComponent={resource4SVGComponent}
                onElementHover={(e) =>
                  onElementHover(resources[3], e.target as SVGElement)
                }
                onElementLeave={() => onElementHover()}
                onElementClick={onClick}
              />
              <ResourceLink
                r={resources[4]}
                svgComponent={resource5SVGComponent}
                onElementHover={(e) =>
                  onElementHover(resources[4], e.target as SVGElement)
                }
                onElementLeave={() => onElementHover()}
                onElementClick={onClick}
              />
              <ResourceLink
                r={resources[5]}
                svgComponent={resource6SVGComponent}
                onElementHover={(e) =>
                  onElementHover(resources[5], e.target as SVGElement)
                }
                onElementLeave={() => onElementHover()}
                onElementClick={onClick}
              />
            </>
          )}
        </g>
      </g>
    </g>
  );
};
export default TechnologySkillsLink;
